import type { PointArray } from '../types/contour-definition-array-type';

/**
 * Calculates the area of a polygon given an array of coordinate points
 *
 * @param {PointArray} polygon - A PointArray defining the polygon
 * @returns {number} The area of the polygon
 *
 */
export function getPolygonArea(polygon: PointArray) {
  if (polygon.length < 3) {
    return 0;
  }

  // Use Shoelace formula (coordinate area formula)
  let area = 0;
  for (let i = 0; i < polygon.length; i++) {
    const j = (i + 1) % polygon.length;
    area += polygon[i].x * polygon[j].y;
    area -= polygon[j].x * polygon[i].y;
  }

  // Take absolute value and divide by 2
  return Math.abs(area) / 2;
}

/**
 * Calculates the area of a polygon given an array of coordinate points
 *
 * @param {number[][]} polygon - A PointArray defining the polygon
 * @returns {number} The area of the polygon
 *
 */
export function getPolygonAreaArray(polygon: number[][]) {
  if (polygon.length < 3) {
    return 0;
  }

  // Use Shoelace formula (coordinate area formula)
  let area = 0;
  for (let i = 0; i < polygon.length; i++) {
    const j = (i + 1) % polygon.length;
    area += polygon[i][0] * polygon[j][1];
    area -= polygon[j][0] * polygon[i][1];
  }

  // Take absolute value and divide by 2
  return Math.abs(area) / 2;
}
